import { Routes } from '@angular/router';
import { AppRoutePaths } from '@core/enums/app-route-paths.enum';
import { AuthGuard } from '@core/guards/auth.guard';
import { EmptyPageComponent } from '@shared/components/empty/empty-page.component';
import { ErrorComponent } from '@shared/components/error/error.component';
import { FeatureGuard } from '@shared/components/feature-toggle/guards/feature.guard';
import { LoadingCircularPanelComponent } from '@shared/components/loading-circular-panel/loading-circular-panel.component';

export const APP_ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: AppRoutePaths.Training },
  { path: AppRoutePaths.Waiting, component: LoadingCircularPanelComponent },
  {
    path: AppRoutePaths.Error,
    component: ErrorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: AppRoutePaths.Training,
    loadChildren: () =>
      import('@training/training.routes').then((m) => m.routes)
  },
  {
    path: AppRoutePaths.Eula,
    component: EmptyPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: AppRoutePaths.Learning,
    loadChildren: () =>
      import('@learning/learning.routes').then((m) => m.routes)
  },
  {
    path: AppRoutePaths.Library,
    loadChildren: () => import('@library/library.routes').then((m) => m.routes)
  },
  {
    path: AppRoutePaths.LibraryFTO,
    loadChildren: () => import('@library/library.routes').then((m) => m.routes)
  },
  {
    path: AppRoutePaths.PreCheckin,
    loadChildren: () =>
      import('@precheckin/precheckin.routes').then((m) => m.routes)
  },
  {
    path: AppRoutePaths.AzureAppInsight,
    loadComponent: () =>
      import(
        '@shared/components/azure-app-insight/azure-app-insight.component'
      ).then((m) => m.AzureAppInsightComponent),
    canActivate: [
      FeatureGuard.canActivateWithFeature('appInsights.showAppInsightComponent')
    ]
  },
  {
    path: AppRoutePaths.User,
    loadChildren: () => import('@user/user.routes').then((m) => m.routes),
    canActivate: [AuthGuard]
  },
  {
    path: AppRoutePaths.AccessPass,
    loadChildren: () =>
      import('@access-pass/access-pass.routes').then((m) => m.routes),
    canActivate: []
  },
  {
    path: '**',
    redirectTo: AppRoutePaths.Training
  }
];
